import type { LinkService, SbLinkProps } from "./link.types";

export const DEFAULT_LINK_PROPS: Omit<SbLinkProps, "seed"> = {
  label: "Link",
  service: "auth",
};

/* ------------------------------------------------------------ */

const SERVICES_REC: Record<LinkService, LinkService> = {
  auth: "auth",
  other: "other",
};

export const LINK_SERVICES: LinkService[] = Object.values(SERVICES_REC);
